import script from "./ChatSidebarBrand.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatSidebarBrand.vue?vue&type=script&setup=true&lang=js"

import "./ChatSidebarBrand.vue?vue&type=style&index=0&id=d10a55aa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d10a55aa"]])

export default __exports__